"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Input = function InputForRangeInput(_ref) {
  var fieldData = _ref.fieldData,
      storedValue = _ref.storedValue,
      eventHandler = _ref.eventHandler,
      steps = _ref.steps;
  return /*#__PURE__*/_react["default"].createElement("input", {
    type: "range",
    name: fieldData.fieldKey,
    min: fieldData.control.options.min,
    max: fieldData.control.options.max,
    step: fieldData.control.options.step,
    value: storedValue,
    onChange: function onChange(event) {
      eventHandler.onChange(event, steps);
    }
  });
};

Input.propTypes = {
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pixels: _propTypes["default"].number,
    threshold: _propTypes["default"].number,
    value: _propTypes["default"].number
  })).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].any.isRequired
  }).isRequired,
  storedValue: _propTypes["default"].number.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func,
    onMouseDown: _propTypes["default"].func,
    setMouseMoveListener: _propTypes["default"].func,
    removeMouseUpListener: _propTypes["default"].func,
    handleMouseUp: _propTypes["default"].func,
    setMouseUpListener: _propTypes["default"].func,
    handleResize: _propTypes["default"].func,
    handleMouseMove: _propTypes["default"].func
  }).isRequired
};
var _default = Input;
exports["default"] = _default;